/**
 * External dependencies
 */
import inherits from 'inherits';

export default class Subscription {
    
    constructor(cscom) {
        if (!(this instanceof Subscription)) {
            return new Subscription(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/subscriptions/list', null, data);
    }

    swap(subscriptionId, newPlanId) {
        return this.cscom.req.post('/customer-site-api/subscriptions/' + subscriptionId + '/swap', null, {
            plan: newPlanId
        });
    }

    getScheduledChanges(subscriptionId) {
        return this.cscom.req.get('/customer-site-api/subscriptions/' + subscriptionId + '/scheduled-changes', null);
    }

    removeScheduledChanges(subscriptionId) {
        return this.cscom.req.del('/customer-site-api/subscriptions/' + subscriptionId + '/scheduled-changes', null);
    }
}
